module.exports = __webpack_public_path__ + "static/media/arrow_down.ca82bc74.svg";